<div class="manage-container">
    <div class="manage-1">
        <button class="manage-2"  (click)="setManageMode()">Manage</button>
    </div>
    <div class="line"></div>
    </div>